import { Nav, Navbar } from 'react-bootstrap';
import React from 'react';
import { useSelector } from 'react-redux';
import { useDocumentTitle } from 'hooks';
import { withRouter } from 'react-router';

import CreateLeadModal from '../../screens/createLeadModal/CreateLeadModal.js';
import { AppHeaderNav } from './AppHeaderNav.js';
import LeadSearchBar from '../LeadSearchBar.js';
import { Link } from 'react-router-dom';
import { brand, logos } from 'images';
import selectors from '../../selectors/selectors.js';
import setQuery from 'lib/setQuery.js';
import AppHeaderUserDropdown from './AppHeaderUserDropdown.js';
import AppHeaderServiceProviderDropdown from './AppHeaderServiceProviderDropdown.js';
import AppNotificationDisplay from 'components/appHeader/AppNotificationDisplay.js';
import sortByProp from 'lib/sortByProp.js';
import { action } from 'lib/actionHelpers.js';

const routesWithNoServiceProvider = ['report', 'dashboard'];

const DefaultAppHeader = (props) => {
  const { pathname } = props.location;
  const pathSplitter = pathname.split('/');

  const user = useSelector((state) => state.user) || {};
  const fullScreenMode = useSelector((state) => state.video.fullScreenMode);
  const serviceProviderId = useSelector(selectors.serviceProviderId);
  const userServiceProviders = (useSelector(selectors.userServiceProviders) || []).sort(sortByProp('name')).filter((n) => n.active !== '0');
  const folderEvents = useSelector(selectors.folderEvents);

  const showComponent = !routesWithNoServiceProvider.includes(pathSplitter[1]);
  const nonLeadIdEvents = (folderEvents.find((n) => n.id === 'inbox') || {}).count || undefined;
  const nonLeadEventsLength = (nonLeadIdEvents || []).length;
  const nonLeadEventsValue = nonLeadEventsLength > 99 ? `99` : nonLeadEventsLength;
  const existingTitle = String(document.title).replace(' | LeadLoop', '').split('|').pop();
  const titlePrefix = nonLeadEventsLength > 0 ? `(${nonLeadEventsValue}) Inquiries | ` : '';
  const newTitle = titlePrefix.length === 0 ? existingTitle : `${titlePrefix}${existingTitle}`;
  const isFixedWidth = useSelector((state) => state.ui.fixedWidth);
  const { serviceProviderIds } = user;

  useDocumentTitle(newTitle);

  if (pathname === '/') {
    return null;
  }

  const handleSearchSelection = (lead) => {
    if (lead && lead.id) {
      setQuery({
        lead: lead.id,
        modal: 'true',
        eid: null,
        etype: null,
        type: null,
      });
    }
  };

  return (
    <>
      <div className={'app-header-wrapper'}>
        <Navbar className={`app-header ${fullScreenMode ? 'full-screen-mode' : ''} ${isFixedWidth ? 'fixed-width' : ''}`} collapseOnSelect expand="lg">
          <div className={'logo-wrapper'}>
            {(serviceProviderIds || []).length > 1 ? (
              <Link to={`/dashboard/service-providers`}>
                <img src={brand['logo-header']} height="40" className="d-inline-block align-top" alt="LeadLoop logo" />
                <div className={'logo-overlay-backing'} />
                <img className={'logo-overlay'} src={logos['leadloop']} alt={'LeadLoop'} />
              </Link>
            ) : (
              <div
                style={{ cursor: 'pointer' }}
                onClick={() => {
                  action('RESET_TO_INITIAL_STATE');
                  window.location.reload();
                }}>
                <img src={brand['logo-header']} height="40" className="d-inline-block align-top" alt="LeadLoop logo" />
                <div className={'logo-overlay-backing'} />
                <img className={'logo-overlay'} src={logos['leadloop']} alt={'LeadLoop'} />
              </div>
            )}
          </div>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <div className="app-header-left">
              {user.loggedIn && serviceProviderId && userServiceProviders.length > 1 && <AppHeaderServiceProviderDropdown />}
              {serviceProviderId && <AppNotificationDisplay />}
            </div>
            <div className="app-header-center">{user.loggedIn && showComponent && <AppHeaderNav />}</div>
            <div className="app-header-right">
              <Navbar id="responsive-navbar-nav">
                {user.loggedIn && serviceProviderId && <LeadSearchBar onSelection={handleSearchSelection} />}
                {serviceProviderId && user.loggedIn && showComponent && <CreateLeadModal />}
                {user.loggedIn && <AppHeaderUserDropdown />}
                {!(pathname || '').includes('/profile') && !user.loggedIn && (
                  <Nav>
                    <Link className={'nav-link'} to={`/login`}>
                      Login
                    </Link>
                  </Nav>
                )}
              </Navbar>
            </div>
          </Navbar.Collapse>
        </Navbar>
      </div>
    </>
  );
};

export default withRouter(DefaultAppHeader);
